export const ProjectListConstants = {
  noInventoryWarning:
    "No Data Available In Inventory For This Launch Phase. Please Contact CRM",
};
